import React from 'react';
import cc from 'classcat';

export const Input = ({ className, type, placeholder, name, id, value, onChange, onKeyDown, onBlur, fullWidth, required, min, max, step }) => {
    return (
        <input
            className={cc(['default-input', className, fullWidth && 'default-input__full-width'])}
            type={type}
            placeholder={placeholder}
            name={name}
            id={id}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            required={required}
            min={min}
            max={max}
            step={step}
        />
    );
};
